import React, { Fragment, PureComponent } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Button, ButtonToolbar, Table } from "reactstrap";

import "./styles.css";
import axios from "axios";
import _ from "lodash";
import Util from '../../Common/util';
import API from '../../Common/api';

class PrintPickingDetail extends PureComponent {
  constructor(props) {
    /*var today = new Date(),
            date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();*/

    var tempDate = new Date();
    var date =
      tempDate.getFullYear() +
      "-" +
      (tempDate.getMonth() + 1) +
      "-" +
      tempDate.getDate() +
      " " +
      tempDate.getHours() +
      ":" +
      tempDate.getMinutes() +
      ":" +
      tempDate.getSeconds();
    const currDate = date;
    super(props);
    this.onLogin = this.onLogin.bind(this);
    this.prinData = this.prinData.bind(this);
    this.state = {
      showPassword: false,
      showPrintData: [],
      date: currDate,
    };

    this.showPassword = this.showPassword.bind(this);
  }

  showPassword(e) {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  }

  componentDidMount() {
    var printDetail_data = localStorage.getItem("printData");
    var printDetails = JSON.parse(printDetail_data);
    /* console.log(printDetail_data);*/
    /*this.setState({
      showPrintData: printDetails
    })*/

    var sorted_data = {};
  for (var username in printDetails) {
    sorted_data[username] = [];
    printDetails[username].map((item) => {
      if (item.lbSkuId != undefined) {
        //sorted_data[username].push(item);
		sorted_data[username] = printDetails[username].sort(function (a, b) {
            var textA = parseInt(a.sequence);
            var textB = parseInt(b.sequence);
            return textA < textB ? -1 : textA > textB ? 1 : 0;
          })
      } else {
        sorted_data[username] = printDetails[username].sort(function (a, b) {
            var textA = parseInt(a[0].sequence);
            var textB = parseInt(b[0].sequence);
            return textA < textB ? -1 : textA > textB ? 1 : 0;
          })
      }
    });
  }
    this.state.showPrintData.push(sorted_data);

    setTimeout(this.prinData, 1100);

    /*if (window.location.href="/putaway/printPutaway") {
          window.location.reload();
        }*/
  }

  prinData() {
    /* for (var i = 0; i < this.state.printDetails.length; i++) {*/
    window.print();

    /*}*/
  }

  onLogin() {
    const payload = {
    
    };
  
  API.post('/auth/oauth2/login', { param: payload })
   
      .then((response) => {
        console.log(response.data.login);
        if (response.data.login === false) {
          window.location.href = response.data.url;
        }
      })
      .catch(function (error) {});
  }

  render() {
    const { handleSubmit } = this.props;
    //   const { showPassword } = this.state;
    const pickType = localStorage.getItem("pickType");
    const arrData = JSON.parse(localStorage.getItem("printData"));
	
	var sorted_data = {};
    for (var username in arrData) {
      sorted_data[username] = [];
      arrData[username].map((item) => {
        if (item.lbSkuId != undefined) {
          //sorted_data[username].push(item);
		  if(item.pickType === "BREAKPACK"){
			 sorted_data[username] = arrData[username].sort(function (a, b) {
              var textA = parseInt(a[0].sequence);
              var textB = parseInt(b[0].sequence);
              return textA < textB ? -1 : textA > textB ? 1 : 0;
            }) 
		  }else{
			 sorted_data[username] = arrData[username].sort(function (a, b) {
              var textA = parseInt(a.sequence);
              var textB = parseInt(b.sequence);
              return textA < textB ? -1 : textA > textB ? 1 : 0;
            }) 
		  }
		  
        } else {
          sorted_data[username] = arrData[username].sort(function (a, b) {
              var textA = parseInt(a[0].sequence);
              var textB = parseInt(b[0].sequence);
              return textA < textB ? -1 : textA > textB ? 1 : 0;
            })
        }
      });
    }
	
    const arrayValue = [];
    arrayValue.push(sorted_data);
    
    console.log("arrayValue = ",arrayValue);
    console.log(arrayValue.sort());
    var userIndex = 0;
	var itemLen = 0;
	var zoneNameArr = []
    return (
      <div className="print_table" style={{ padding: 15 }}>
        {arrayValue.map((item,itemIndex) =>
			
          _.map(item, (value, key) => (
		    
            <div style={{ width: "100%" }}>
				<span style={{display:'none'}}>{userIndex = userIndex + 1}</span>
				<span style={{display:'none'}}>{itemLen = Object.keys(item).length}</span>
					<span style={{display:'none'}}>{zoneNameArr = []}</span>
              <div
                className="separater"
                style={{ marginBottom: 20, borderBottomWidth: 1 }}
              >
			  
                {/* <div className="margin_space" style={{position: 'fixed', top: 0, left: 0 , right: 0, width: '100%'}}>
                  <h5 style={{width: '30%', float: 'left', marginBottom: 15}}> <span style={{fontWeight: 'bold'}}> User Name: </span> <span> {key} </span> </h5>
                  <h5 style={{width: '40%', float: 'left', marginBottom: 15}}> <span style={{fontWeight: 'bold'}}> PTL ID: </span> <span> {value[0].ptlId} / </span> <span style={{fontWeight: 'bold'}}> Pick Type: </span> <span> {value[0].pickType} / </span> <span style={{fontWeight: 'bold'}}> Zone Id: </span> <span> {value[0].ptlZone}  </span> </h5>
                  <h5 style={{width: '30%', float: 'left', textAlign: 'right', marginBottom: 15}}><span style={{fontWeight: 'bold'}}> Date: </span> <span> {this.state.date} </span></h5>
                  
                  </div>*/}

                {pickType === "ICLD_LOOSE" ? (
                  <Table
                    responsive
                    className="table table--bordered"
                    style={{ marginBottom: 50 }}
                  >
                    <thead
                      className="thead_align"
                      style={{ background: "#ccc" }}
                    >
                      <tr style={{ marginTop: 20, background: "#fff" }}>
                        <th colspan="3" style={{ marginTop: 20 }}>
                          <h5>
                            {" "}
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              User Name:{" "}
                            </span>{" "}
                            <span> {key} </span>{" "}
                          </h5>
                        </th>

                       {(value[0][0].pickType.toLowerCase() == "loose" && value[0][0].tester == true) ? 
                        <th colspan="2" style={{ marginTop: 20 }}>
                        <h5 style={{ textAlign: "center" }}>
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            {value[0][0].pickType.toLowerCase() == "carton" ||
                            value[0][0].pickType.toLowerCase() == "outer"
                              ? "CPS ID :"
                              : "PTL ID :"}{" "}
                          </span>
                          <span>
                            {" "}
                            {value[0][0].pickType.toLowerCase() == "carton" ||
                            value[0][0].pickType.toLowerCase() == "outer"
                              ? value[0][0].ptlId
                              : value[0][0].ptlId}{" "}
                            /{" "}
                          </span>
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Pick Type:{" "}
                          </span>{" "}
                          <span> {value[0][0].pickType} / </span>
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Zone Id:{" "}
                          </span>{" "}
                          <span> {value[0][0].ptlZone} </span>
                        </h5>
                      </th> 
                       : <th colspan="5" style={{ marginTop: 20 }}>
                          <h5 style={{ textAlign: "center" }}>
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              {value[0][0].pickType.toLowerCase() == "carton" ||
                              value[0][0].pickType.toLowerCase() == "outer"
                                ? "CPS ID :"
                                : "PTL ID :"}{" "}
                            </span>
                            <span>
                              {" "}
                              {value[0][0].pickType.toLowerCase() == "carton" ||
                              value[0][0].pickType.toLowerCase() == "outer"
                                ? value[0][0].ptlId
                                : value[0][0].ptlId}{" "}
                              /{" "}
                            </span>
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Pick Type:{" "}
                            </span>{" "}
                            <span> {value[0][0].pickType} / </span>
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Zone Id:{" "}
                            </span>{" "}
                            <span> {value[0][0].ptlZone} </span>
                          </h5>
                        </th>
                       }
                        <th colspan="2" style={{ marginTop: 20 }}>
                          {" "}
                          <h5 style={{ textAlign: "right" }}>
                            <span style={{ fontWeight: "bold" }}> Date: </span>{" "}
                            <span> {this.state.date} </span>
                          </h5>{" "}
                        </th>
                      </tr>

                      <tr style={{ marginTop: 20 }}>
                        <th style={{ marginTop: 20 }}> BIN Address</th>

                        {value[0][0].tester === false && (
                          <th style={{ marginTop: 20 }}> Zone Name </th>
                        )}

                        {(value[0][0].pickType.toLowerCase() == "carton" ||
                          value[0][0].pickType.toLowerCase() == "outer" ||
                          value[0][0].pickType.toLowerCase() == "breakpack") && (
                          <th style={{ marginTop: 20 }}> Order Id</th>
                        )}

                        <th style={{ marginTop: 20 }}> LB SKU ID </th>
                        <th style={{ marginTop: 20 }}> Basepack Code </th>
                        {value[0][0].tester === false && (
                          <th style={{ marginTop: 20 }}> CBU Code </th>
                        )}

                        {value[0][0].tester === false && (
                          <th style={{ marginTop: 20 }}> PKD </th>
                        )}

                        <th style={{ marginTop: 20 }}>
                          {" "}
                          LB SKU ID Description{" "}
                        </th>

                        {value[0][0].tester === false && (
                          <th style={{ marginTop: 20 }}>
                            {" "}
                            ICLD Quantity(Box){" "}
                          </th>
                        )}

                        {value[0][0].tester === false && (
                          <th style={{ marginTop: 20 }}>
                            {" "}
                            Total Loose Quantity(pcs){" "}
                          </th>
                        )}

                        {value[0][0].tester === true && (
                          <th style={{ marginTop: 20 }}>
                            {" "}
                            Total Tester Quantity(pcs){" "}
                          </th>
                        )}
                        <th style={{ marginTop: 20 }}> Total Quantity(pcs) </th>
                      </tr>
                    </thead>
                    <tbody>
                      {value.map((insideItem, index) => (
                        <Fragment>
                          {_.map(insideItem, (value1, key) => (
						    
                            <tr
							
                              style={{
                                borderTop:
								  value1.pickType.toLowerCase() == "breakpack" &&
								  zoneNameArr.indexOf(value1.OrderId) === -1 ?
								  "4px solid green":
                                  insideItem.length > 1 && key === 0
                                    ? "4px solid green"
                                    : "inherit",
                                }}
                            >
							{value1.pickType.toLowerCase() == "breakpack" &&
							 zoneNameArr.indexOf(value1.OrderId) === -1 &&
							<span style={{display:"none"}}>{zoneNameArr.push(value1.OrderId)}</span>}
                              <td> {value1.binAddress}</td>

                              {value1.tester === false && (
                                <td> {value1.zoneName} </td>
                              )}

                              {(value1.pickType.toLowerCase() == "carton" ||
                                value1.pickType.toLowerCase() == "outer"||
                                value1.pickType.toLowerCase() == "breakpack") && (
                                <td> {value1.OrderId} </td>
                              )}

                              <td> {value1.lbSkuId} </td>
                              <td> {value1.basepackCode} </td>

                              {value1.tester === false && (
                                <td> {value1.cbuCode} </td>
                              )}

                              {value1.tester === false && (
                                <td> {value1.pkd} </td>
                              )}

                              <td> {value1.lbSkuProductName} </td>
                              {value1.tester === false && (
                                <td> {value1.totalIcldQty} </td>
                              )}

                              {value1.tester === false && (
                                <td> {value1.totalLooseQty} </td>
                              )}

                              {value1.tester === true && (
                                <td> {value1.totalTesterQty} </td>
                              )}
                              <td> {value1.totalQty} </td>
                            </tr>
                          ))}
                        </Fragment>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <Table
                    responsive
                    className="table table--bordered"
                    style={{ marginBottom: 50 }}
                  >
                    <thead
                      className="thead_align"
                      style={{ background: "#ccc" }}
                    >
                      <tr style={{ marginTop: 20, background: "#fff" }}>
                        <th colspan="3" style={{ marginTop: 20 }}>
                          <h5>
                            {" "}
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              User Name:{" "}
                            </span>{" "}
                            <span> {key} </span>{" "}
                          </h5>
                        </th>

                        <th colspan="5" style={{ marginTop: 20 }}>
                          <h5 style={{ textAlign: "center" }}>
                            <span style={{ fontWeight: "bold" }}>
                              {value[0].pickType.toLowerCase() == "carton" ||
                              value[0].pickType.toLowerCase() == "outer"
                                ? "CPS ID :"
                                : "PTL ID :"}
                            </span>
                            <span>
                              {" "}
                              {value[0].pickType.toLowerCase() == "carton" ||
                              value[0].pickType.toLowerCase() == "outer"
                                ? value[0].ptlId
                                : value[0].ptlId}{" "}
                              /{" "}
                            </span>
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Pick Type:{" "}
                            </span>
                            <span> {value[0].pickType} / </span>
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Zone Id:{" "}
                            </span>
                            <span> {value[0].ptlZone} </span>
                          </h5>
                        </th>

                        <th colspan="4" style={{ marginTop: 20 }}>
                          {" "}
                          <h5 style={{ textAlign: "right" }}>
                            <span style={{ fontWeight: "bold" }}> Date: </span>{" "}
                            <span> {this.state.date} </span>
                          </h5>{" "}
                        </th>
                      </tr>

                      <tr style={{ marginTop: 20 }}>
                        <th style={{ marginTop: 20 }}> BIN Address</th>
                        {value[0].tester === false && (
                          <th style={{ marginTop: 20 }}> Zone Name </th>
                        )}

                        {(value[0].pickType.toLowerCase() == "carton" ||
                          value[0].pickType.toLowerCase() == "outer") && (
                          <th style={{ marginTop: 20 }}> Order Id</th>
                        )}

                        <th style={{ marginTop: 20 }}> LB SKU ID </th>
                        <th style={{ marginTop: 20 }}> Basepack Code </th>
                        {value[0].tester === false && (
                          <th style={{ marginTop: 20 }}> CBU Code </th>
                        )}

                        {value[0].tester === false && (
                          <th style={{ marginTop: 20 }}> PKD </th>
                        )}

                        <th style={{ marginTop: 20 }}>
                          {" "}
                          LB SKU ID Description{" "}
                        </th>

                        {value[0].tester === false && (
                          <th style={{ marginTop: 20 }}>
                            {" "}
                            ICLD Quantity(Box){" "}
                          </th>
                        )}

                        {value[0].tester === false && (
                          <th style={{ marginTop: 20 }}>
                            {" "}
                            Total Loose Quantity(pcs){" "}
                          </th>
                        )}

                        {value[0].tester === true && (
                          <th style={{ marginTop: 20 }}> Shade code </th>
                        )}

                        {value[0].tester === true && (
                          <th style={{ marginTop: 20 }}> Shade Name </th>
                        )}

                        {value[0].tester === true && (
                          <th style={{ marginTop: 20 }}> Date </th>
                        )}

                        {value[0].tester === true && (
                          <th style={{ marginTop: 20 }}> Party Code </th>
                        )}

                        {value[0].tester === true && (
                          <th style={{ marginTop: 20 }}> Party Name </th>
                        )}

                        {value[0].tester === true && (
                          <th style={{ marginTop: 20 }}> Sales Beat </th>
                        )}

                        {value[0].tester === true && (
                          <th style={{ marginTop: 20 }}>
                            {" "}
                            Total Tester Quantity(pcs){" "}
                          </th>
                        )}
                        <th style={{ marginTop: 20 }}> Total Quantity(pcs) </th>
                      </tr>
                    </thead>
                    <tbody>
                      {value.map((insideItem, index) => (
                        <tr
                          style={{
                            borderTop:
							  insideItem.pickType.toLowerCase() == "breakpack" &&
								  zoneNameArr.indexOf(insideItem.OrderId) === -1 ?
								  "4px solid green":
                              (insideItem.party_code !=
                              value[index === 0 ? index : index - 1].party_code)
                                ? "4px solid green"
                                : "inherit",
                          }}
                        >
						{insideItem.pickType.toLowerCase() == "breakpack" &&
							 zoneNameArr.indexOf(insideItem.OrderId) === -1 &&
							<span style={{display:"none"}}>{zoneNameArr.push(insideItem.OrderId)}</span>}
                          <td> {insideItem.binAddress}</td>

                          {insideItem.tester === false && (
                            <td> {insideItem.zoneName} </td>
                          )}

                          {(insideItem.pickType.toLowerCase() == "carton" ||
                            insideItem.pickType.toLowerCase() == "outer") && (
                            <td> {insideItem.OrderId} </td>
                          )}
                          <td> {insideItem.lbSkuId} </td>
                          <td> {insideItem.basepackCode} </td>

                          {insideItem.tester === false && (
                            <td> {insideItem.cbuCode} </td>
                          )}

                          {insideItem.tester === false && (
                            <td> {insideItem.pkd} </td>
                          )}

                          <td> {insideItem.lbSkuProductName} </td>
                          {insideItem.tester === false && (
                            <td> {insideItem.totalIcldQty} </td>
                          )}

                          {insideItem.tester === false && (
                            <td> {insideItem.totalLooseQty} </td>
                          )}

                          {insideItem.tester === true && (
                            <td> {insideItem.shade_code} </td>
                          )}

                          {insideItem.tester === true && (
                            <td> {insideItem.shade_name} </td>
                          )}

                          {insideItem.tester === true && (
                            <td> {insideItem.date} </td>
                          )}

                          {insideItem.tester === true && (
                            <td> {insideItem.party_code} </td>
                          )}

                          {insideItem.tester === true && (
                            <td> {insideItem.party_name} </td>
                          )}

                          {insideItem.tester === true && (
                            <td> {insideItem.sales_beat} </td>
                          )}

                          {insideItem.tester === true && (
                            <td> {insideItem.totalTesterQty} </td>
                          )}
                          <td> {insideItem.totalQty} </td>
                        </tr>
                      ))}
                    </tbody>
					
                  </Table>
                )}
				
              </div>
			  {userIndex !== itemLen &&
			  <div className="page-break" name={userIndex} items={itemLen}></div>}
            </div>
          ))
        )}
		
      </div>
    );
  }
}

export default PrintPickingDetail;